import { SVGProps, memo } from 'react';

const PptIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.9126 13.2713C19.9126 15.0733 19.3783 16.8348 18.3771 18.3331C17.376 19.8315 15.953 20.9993 14.2882 21.6889C12.6233 22.3784 10.7914 22.5589 9.024 22.2073C7.25662 21.8558 5.63317 20.988 4.35896 19.7138C3.08474 18.4396 2.21699 16.8161 1.86544 15.0488C1.51389 13.2814 1.69432 11.4494 2.38392 9.7846C3.07351 8.11976 4.24131 6.6968 5.73962 5.69566C7.23794 4.69451 8.99948 4.16016 10.8015 4.16016V13.2713H19.9126Z'
      fill='#EF6C00'
    />
    <path
      d='M13.0793 1.88253C14.2758 1.88253 15.4605 2.1182 16.566 2.57607C17.6714 3.03395 18.6758 3.70507 19.5218 4.55112C20.3679 5.39716 21.039 6.40156 21.4969 7.50698C21.9547 8.61239 22.1904 9.79716 22.1904 10.9937L13.0793 10.9937L13.0793 1.88253Z'
      fill='#EF6C00'
    />
  </svg>
);

export default memo(PptIcon);
